var gfx = require('./graphics2017.js');
var $ = require('jquery');

var _this = {};

_this.main = function() {

	$(document).ready(function($) {

	  gfx.setup();
	  var win = $(window);

	  win.on('resize', function(){
	    gfx.updateDimensions(win.width(), win.height());
	  });

	  // win.on('scroll', gfx.scroll);


	  //Menu 
	  var menuToggler = function() {
	    var nav = $($('nav.nav-mobile')[0]);
	    if (nav.hasClass('hidden')) {
	      nav.removeClass('hidden');
	    } else {
	      nav.addClass('hidden');
	    }
	  }

	  $('#menu-trigger').on('click', menuToggler);
	  $('#menu-title').on('click', menuToggler);

	  $('#content').on('click', function() {

	  	var nav = $($('nav.nav-mobile')[0]);

	  	if (!nav.hasClass('hidden')) {
	  		nav.addClass('hidden');
	  	}

	  })

	  //Schedule
	  _this.setScheduleHash();

	});

}

var firstRun = true;
var dayHash;

_this.setScheduleHash = function() {
	console.log('setScheduleDate', dayHash);

	if (firstRun) {
  		$('a.schedule-day-link').click(function(){ console.log('link click'); _this.setScheduleHash(); });
  		firstRun = false;
  		dayHash = window.location.hash.substr(1);
  		_this.setScheduleDate();
	} else {
		setTimeout(function(){ dayHash = window.location.hash.substr(1); _this.setScheduleDate(); console.log('dayHash', dayHash)}, 500);
	}
}


_this.setScheduleDate = function() {
	$('a.schedule-day-link').each(function(){
		$(this).removeClass('active');
		if ($(this).hasClass(dayHash)) { $(this).addClass('active'); }
	});
}

_this.main();


module.exports = _this;



//////////////////
// WEBPACK FOOTER
// ./scripts/index.js
// module id = 0
// module chunks = 0